<script setup>
defineProps({
  language: {
    type: String,
    default: "en"
  },
  country: {
    type: String,
    default: "gb"
  }
});
import CityList from "./CityList.vue";
defineEmits(["closeCityFooter"]);
</script>

<template>
    <div id="city-footer">
        <IconClose class="size-4" @click="$emit('closeCityFooter')" />
        <CityList :language :country />
    </div>
</template>

<style scoped>
#city-footer {
  @apply w-full bg-white border-t-[1px];
  box-shadow: 0px -3px 5px 0px rgba(0, 0, 0, 0.1);
}
#city-footer svg {
  @apply h-4 w-4 cursor-pointer text-zinc-600 hover:text-black absolute top-4 right-4;
}
</style>
